export const view04ImageOptions = {
  angle: 'view04',
  staticOptions: {
    HullColour: 1,
    BiminiColor: 1,
    UpholsteryCockpit: 1,
    Engine: 1,
    AnchorStern: 1,
    AnchorBow: 1
  },
  mattes: [
    {
      option: 'UpholsteryCockpit',
      dependency: 'TTop'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view04.js